import requester from '@/lib/axios';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';
import { ContentCreatorCourse, ContentCreatorCourseDTO } from '@/models/Course';

export type ListContentCreatorCourseFilter = {
  contentCreatorId?: number[];
  courseId?: number[];
  ordering?: string;
} & BaseFilters;

export const listContentCreatorCourses = async (
  params: ListContentCreatorCourseFilter = {},
) => {
  const { data } = await requester().get<JsonApiResponse<ContentCreatorCourse>>(
    'content-creator-courses/',
    {
      params,
    },
  );

  return data;
};

export const getContentCreatorCourse = async (id: number) => {
  const { data } = await requester().get<ContentCreatorCourse>(
    `content-creator-courses/${id}/`,
  );
  return data;
};

export const createContentCreatorCourse = async (
  contentCreatorCourse: Omit<ContentCreatorCourseDTO, 'id'>,
) => {
  const { data } = await requester().post<ContentCreatorCourse>(
    'content-creator-courses/',
    contentCreatorCourse,
  );

  return data;
};

export const deleteContentCreatorCourse = async (id: number) => {
  return await requester().delete(`content-creator-courses/${id}/`);
};

export const updateContentCreatorCourse = async (
  id: number,
  contentCreatorCourse: Partial<ContentCreatorCourseDTO>,
) => {
  const { data } = await requester().patch<ContentCreatorCourse>(
    `content-creator-courses/${id}/`,
    contentCreatorCourse,
  );

  return data;
};
